import React from 'react';
import { Container } from 'react-bootstrap';
import Layout from '../components/layout/Layout';
import BulkUpload from '../components/clients/BulkUpload';

const BulkUploadPage = () => {
  return (
    <Layout>
      <Container>
        <h2 className="mb-4 page-title">Bulk Upload Clients</h2>
        <p className="text-muted mb-4">
          Upload multiple clients at once using a CSV file. Download the template to see the required format.
        </p>
        <BulkUpload />
      </Container>
    </Layout>
  );
};

export default BulkUploadPage;
